import React from 'react';

import { StyledText } from './styled';

interface Props {
  children: React.ReactNode;
  size?: 'xs' | 's' | 'm' | 'l' | 'xl';
}

const Text = ({ children, size = 'm', ...htmlProps }: Props) => {
  return (
    <StyledText size={size} {...htmlProps}>
      {children}
    </StyledText>
  );
};

export default Text;
